export const MODALS = Object.freeze({
  ADMIN_PHONE_CASE_ADD: 'ADMIN_PHONE_CASE_ADD',
  ADMIN_PHONE_CASE_EDIT: 'ADMIN_PHONE_CASE_EDIT',
  ADMIN_TAG_ADD: 'ADMIN_TAG_ADD',
  ADMIN_TAG_EDIT: 'ADMIN_TAG_EDIT',
  ADMIN_STOCK_ADD: 'ADMIN_STOCK_ADD',
  ADMIN_STOCK_EDIT: 'ADMIN_STOCK_EDIT',
  ADMIN_LOCALIZATION_ADD: 'ADMIN_LOCALIZATION_ADD',
  ADMIN_LOCALIZATION_EDIT: 'ADMIN_LOCALIZATION_EDIT',
  ADMIN_ORDER_LINE_ADD: 'ADMIN_ORDER_LINE_ADD',
  ADMIN_ORDER_LINE_EDIT: 'ADMIN_ORDER_LINE_EDIT',
  REGISTRATION: 'REGISTRATION',
  LOGIN: 'LOGIN',
});
